import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { useAppSelector } from "../../../../infra/hooks";

interface MyTeamDTOProps {
  setAllCountries: (countries: []) => void;
  setAllGenders: (genders: []) => void;
  setAllMaritalStatus: (maritalStatus: []) => void;
}
function DTOPopupModal({
  setAllCountries,
  setAllGenders,
  setAllMaritalStatus,
}: MyTeamDTOProps) {
  const companyId = useAppSelector((state) => state.authSlice.company_id);

  async function getAllCountries() {
    const response = await commonServices.getCountries();
    if (response) {
      const { data }: any = response;
      setAllCountries(data);
    }
  }

  async function getAllGenders() {
    const response = await commonServices.getCompanyGenders(companyId);
    if (response) {
      const { data }: any = response;
      setAllGenders(data);
    }
  }

  async function getAllMaritalStatus() {
    const response = await commonServices.getCompanyMaritalStatus(companyId);
    if (response) {
      const { data }: any = response;
      console.log("response marital status--", data);
      setAllMaritalStatus(data);
    }
  }
  useEffect(() => {
    getAllCountries();
    getAllGenders();
    getAllMaritalStatus();
  }, []);

  return <></>;
}
export default DTOPopupModal;
